export default class Load {
    constructor() {
        this.init();
    }

    init() {
        this.addLoad();
    }

    addLoad() {
        const $body = document.body;
        window.addEventListener('load', $body.classList.add('-loadready'));
    }
}